module.exports = __webpack_public_path__ + "img/default_banner.2b2f3d69.svg";